/* biome-ignore-all lint/suspicious/noExplicitAny: legacy data structure */
import type { PageQueryParams } from "@/types/global"
import { HttpRequest } from "@/utils/request"

export interface SpeechAssessmentPhoneme {
  Phoneme: string
  PronunciationAssessment?: {
    AccuracyScore?: number
    ErrorType?: string
  }
}

export interface SpeechAssessmentWord {
  Word: string
  PronunciationAssessment?: {
    AccuracyScore?: number
    ErrorType?: string
    Feedback?: {
      Prosody?: {
        Break?: {
          ErrorTypes?: string[]
          BreakLength?: number
        }
      }
    }
  }
  Phonemes?: SpeechAssessmentPhoneme[]
  Syllables?: Array<{
    Syllable?: string
    PronunciationAssessment?: {
      AccuracyScore?: number
    }
  }>
}

export interface SpeechAssessmentData {
  RecognitionStatus?: string
  Offset?: number
  Duration?: number
  NBest?: Array<{
    Confidence?: number
    Lexical?: string
    ITN?: string
    MaskedITN?: string
    Display?: string
    PronunciationAssessment?: {
      AccuracyScore?: number
      FluencyScore?: number
      CompletenessScore?: number
      PronScore?: number
      ProsodyScore?: number
    }
    Words?: SpeechAssessmentWord[]
  }>
}

export interface SpeechAssessmentLogItem {
  id: number
  user_id: number | null
  reference_text: string | null
  audio_path: string | null
  audio_url?: string | null
  audio_size: number | null
  audio_duration: number | string | null
  latency_ms: number | null
  pron_score: number | string | null
  is_success: number | boolean
  error_message: string | null
  ip_address: string | null
  user_agent: string | null
  assessment_data: SpeechAssessmentData | string | null
  created_at: string
  user?: {
    id: number
    name: string
    email: string
    username: string
    avatar?: string
  } | null
}

export interface SpeechAssessmentStats {
  total: number
  success_count: number
  success_rate: number
  avg_pron_score: number
  avg_latency: number
}

export interface SpeechAssessmentQueryParams extends Partial<PageQueryParams> {
  limit?: number
  search?: string
  reference_text?: string
  user_id?: number
  user_search?: string
  status?: string
  score_range?: string
  start_date?: string
  end_date?: string
}

export interface SpeechAssessmentListResponse {
  code: number
  data: SpeechAssessmentLogItem[]
  total: number
  page: number
  limit: number
  stats?: SpeechAssessmentStats
}

export const speechAssessmentService = {
  list(params: SpeechAssessmentQueryParams) {
    return HttpRequest.get("v1/speech-assessment-logs", {
      searchParams: params as any,
    }).json<SpeechAssessmentListResponse>()
  },

  getStats(params: SpeechAssessmentQueryParams) {
    return HttpRequest.get("v1/speech-assessment-logs/stats", {
      searchParams: params as any,
    }).json<{
      code: number
      data: SpeechAssessmentStats
    }>()
  },

  getDetail(id: number) {
    return HttpRequest.get(`v1/speech-assessment-logs/${id}`).json<{
      code: number
      data: SpeechAssessmentLogItem
    }>()
  },
}
